import { withFormsy } from 'formsy-react';
import React from 'react';

class Checkbox extends React.Component {

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    this.props.setValue(event.currentTarget.checked);
  }

  render() {

    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();
    const showRequired = this.props.showRequired();

    const {
      showErrors = false,
      placeholder = "",
      label = null,
      required = false,
      name,
      inputSize = ""
    } = this.props;

    const hasError = showErrors && errorMessage;

    return (
      <div className={"pt-form-group"}>
        <div className={"pt-form-content" + (hasError ? " pt-intent-danger" : "")}>
          <div className={"pt-checkbox "+ (inputSize) + (hasError ? " pt-intent-danger" : "")}>
            <label className="pt-control pt-checkbox .modifier">
              <input id={name}
                     className="pt-control-indicator"
                     dir="auto"
                     onChange={this.changeValue}
                     type="checkbox"
                     placeholder={placeholder}
                     checked={this.props.getValue() || ''}/>
              <span className="pt-control-indicator"></span>
              {label}
              {required && (
                <span className="f5 pt-text-muted">(required)</span>
              )}
            </label>
          </div>
          <div className="pt-form-helper-text">
            <div className="inline-error">
              {(showErrors && errorMessage) ? (errorMessage) :
               (showErrors && showRequired) ? "Field is required." : ""}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withFormsy(Checkbox);


// WEBPACK FOOTER //
// ./src/components/form/Checkbox.js